export default __webpack_public_path__ + "static/media/document.9880efb9.svg";